// extracted by mini-css-extract-plugin
export default {"downloadButton":"Download_downloadButton__wfq2A","icon":"Download_icon__wFMDX","disabled":"Download_disabled__TQh3-"};